import React from "react";
import { Home } from "./pages/Home";
import { NewPatient } from "../src/pages/NewPatient";

import { PatientContact } from "../src/components/FormComponents/PatientContact";
import { PhysicianOrder } from "../src/components/FormComponents/PhysicianOrder";
import { ConfirmAppointment } from "./components/FormComponents/ConfirmAppointment";
import { SummaryAppointment } from "./components/FormComponents/SummaryAppointment";
import { Navigate } from "react-router-dom";
import { CancelAppointment } from "./components/CancelAppointment/CancelAppointment";
import { CurrentOrders } from "./components/CancelAppointment/ CurrentOrders/ CurrentOrders";
import SessionsComponent from "./components/CancelAppointment/ CurrentOrders/components/SessionsComponent";
import PatientContinuity from "./components/ PatientContinuity/ PatientContinuity";
import { OrderPatientContinuity } from "./components/ PatientContinuity/CurrentOrders/OrderPatientContinuity";
import {SessionProgramaded} from "./components/ PatientContinuity/SessionProgramaded/SessionProgramaded";
import {ResumenCitaContinuidad} from "./components/ PatientContinuity/SumaryAppointment/ConfirmAppointment";

const AppRoutes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/PacienteNuevo",
    element: <NewPatient />,
  },
  {
    path: "contacto",
    element: <PatientContact />,
  },
  {
    path: "orden",
    element: <PhysicianOrder />,
  },
  {
    path: "/ConfirmarCita",
    element: <ConfirmAppointment />,
  },
  {
    path: "/ResumenCita",
    element: <SummaryAppointment />,
  },
  {
    path: "/CancelarCita",
    element: <CancelAppointment />,
  },
  {
    path: "/OrdenesVigentes",
    element: <CurrentOrders />,
  },
  {
    path: "/Sesiones",
    element: <SessionsComponent />,
  },
  {
    path: "/Continuidad",
    element: <PatientContinuity />,
  },
  {
    path: "/OrderContinuidad",
    element: <OrderPatientContinuity />,
  },
  {
    path: "/SesionProgramada",
    element: <SessionProgramaded />,
  },
  {
    path: "/ResumenCitaContinuidad",
    element: <ResumenCitaContinuidad />,
  },
  {
    path: "/*",
    element: <Navigate to="/" />,
  },
];

export default AppRoutes;
